'use strict';

angular.module('amexReconciliationApp')
  .constant('roles', {
    CARDMEMBER: 'CMP$CPCCARDMEM',
    CARD_MANAGER: 'CMP$CPCCARDMGR',
    BCA_MANAGER: 'CMP$CPCBCAMGR',
    ACCOUNTING_MANAGER: 'CMP$CPCLNKMGR',
    LIMITED_CARDMEMBER: 'CMP$CPCLIMCARDMEM',
    LIMITED_CARD_MANAGER: 'CMP$CPCLIMCARDMGR',
    LIMITED_BCA_MANAGER: 'CMP$CPCLIMBCAMGR',
    LIMITED_ACCOUNTING_MANAGER: 'CMP$CPCLIMLNKMGR',
    BTA_MANAGER: 'CMP$CPCBTAMGR',
  })
  .constant('commercialRecon', {
      DEV: 'https://commercial-recon-dev.americanexpress.com/',
      QA: 'https://commercial-recon-qa.americanexpress.com/',
      PRODUCTION: 'https://commercial-recon.americanexpress.com/',
    })
  .constant('newBta', {
      url: '/business/commercial/reconciliation/bta-intl/transaction-details',
      NON_BTA_INTL: 'NON_BTA_INTL',
      URL_PARAMS: 'urlParams',
      COOKIE_EXPIRY_DAY: 1,
  })
  .constant('languages', [
    'EN_US',
    'EN_GB',
    'EN_AU',
    'EN_CA',
    'FR_CA',
    'FR_FR',
    'ES_ES',
    'ES_LA',
    'PT_BR',
    'DE_DE',
    'SV_SE',
    'IT_IT',
    'NL_NL'
  ])
  .constant('dateFormats', {
    MONTH_DAY_YEAR_SLASH: 'MM/dd/yy',
    DAY_MONTH_YEAR_SLASH: 'dd/MM/yy',
    DAY_MONTH_YEAR_DASH: 'dd-MM-yy',
    YEAR_MONTH_DAY_DASH: 'yy-MM-dd',
    DAY_MONTH_YEAR_DOT: 'dd.MM.yy'
  })
  .constant('currencyFormats', [
    'PERIOD',
    'COMMA'
  ])
  .constant('advancedSearch', {
    MAX_SEARCH_CRITERIA: 8
  })
  .constant('print', {
    MAX_TRANSACTIONS_DISPLAYED: 500
  })
  .constant('booleanConstants', {
    TRUE : true,
    FALSE : false
  });

var Bloodhound = require('bloodhound-js');
angular.module('amexReconciliationApp')
  .value('Bloodhound', Bloodhound);

angular.module('amexReconciliationApp')
  .factory('actionStatusMappings', function (roles) {
    var actionStatusMappings = {};
    actionStatusMappings[roles.CARDMEMBER] = 'cardmemberSubmitted';
    actionStatusMappings[roles.LIMITED_CARDMEMBER] = 'cardmemberSubmitted';
    actionStatusMappings[roles.CARD_MANAGER] = 'cardManagerApproved';
    actionStatusMappings[roles.LIMITED_CARD_MANAGER] = 'cardManagerApproved';
    actionStatusMappings[roles.BCA_MANAGER] = 'bcaManagerApproved';
    actionStatusMappings[roles.LIMITED_BCA_MANAGER] = 'bcaManagerApproved';
    actionStatusMappings[roles.ACCOUNTING_MANAGER] = 'accountingManagerApproved';
    actionStatusMappings[roles.LIMITED_ACCOUNTING_MANAGER] = 'accountingManagerApproved';

    return actionStatusMappings;
  });

angular.module('amexReconciliationApp')
  .factory('urls', function (roles) {
    var BASE_URI = '/api/v1/transactions/';

    var urls = {};

    urls[roles.CARDMEMBER] = {
      all: {
        count: BASE_URI + 'search/countByBillingDate',
        filter: BASE_URI + 'search/findByBillingDate',
        allocations: BASE_URI + 'search/findAllocationsByBillingDate',
        advancedSearch: BASE_URI + 'searchByCardForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByCard',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByCardCount',
        print: BASE_URI + 'print/card'
      }
    };

    urls[roles.LIMITED_CARDMEMBER] = {
      all: {
        count: BASE_URI + 'search/countByBillingDate',
        filter: BASE_URI + 'search/findByBillingDate',
        allocations: BASE_URI + 'search/findAllocationsByBillingDate',
        advancedSearch: BASE_URI + 'searchByCardForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByCard',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByCardCount',
        print: BASE_URI + 'print/card'
      }
    };

    urls[roles.CARD_MANAGER] = {
      all: {
        count: BASE_URI + 'search/countByBillingDate',
        filter: BASE_URI + 'search/findByBillingDate',
        allocations: BASE_URI + 'search/findAllocationsByBillingDate',
        advancedSearch: BASE_URI + 'searchByCardForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByCard',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByCardCount',
        print: BASE_URI + 'print/card'
      }
    };

    urls[roles.LIMITED_CARD_MANAGER] = {
      all: {
        count: BASE_URI + 'search/countByBillingDate',
        filter: BASE_URI + 'search/findByBillingDate',
        allocations: BASE_URI + 'search/findAllocationsByBillingDate',
        advancedSearch: BASE_URI + 'searchByCardForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByCard',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByCardCount',
        print: BASE_URI + 'print/card'
      }
    };

    urls[roles.BCA_MANAGER] = {
      all: {
        count: BASE_URI + 'search/countByBillingDateForBcaManager',
        filter: BASE_URI + 'search/findByBillingDateForBcaManager',
        allocations: BASE_URI + 'search/findAllocationsByBillingDateForBcaManager',
        advancedSearch: BASE_URI + 'searchByBcaForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByBca',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByBcaCount',
        print: BASE_URI + 'print/bca'
      }
    };

    urls[roles.LIMITED_BCA_MANAGER] = {
      all: {
        count: BASE_URI + 'search/countByBillingDateForBcaManager',
        filter: BASE_URI + 'search/findByBillingDateForBcaManager',
        allocations: BASE_URI + 'search/findAllocationsByBillingDateForBcaManager',
        advancedSearch: BASE_URI + 'searchByBcaForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByBca',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByBcaCount',
        print: BASE_URI + 'print/bca'
      }
    };

    urls[roles.ACCOUNTING_MANAGER] = {
      all: {
        count: BASE_URI + 'search/countByAccountingLineBillingCycle',
        filter: BASE_URI + 'search/findByAccountingLineBillingCycle',
        allocations: BASE_URI + 'search/findAllocationsByAccountingLineBillingCycle',
        advancedSearch: BASE_URI + 'searchByAccountingLineForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByAccountingLine',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByAccountingLineCount',
        print: BASE_URI + 'print/accountingLine'
      }
    };

    urls[roles.LIMITED_ACCOUNTING_MANAGER] = {
      all: {
        count: BASE_URI + 'search/countByAccountingLineBillingCycle',
        filter: BASE_URI + 'search/findByAccountingLineBillingCycle',
        allocations: BASE_URI + 'search/findAllocationsByAccountingLineBillingCycle',
        advancedSearch: BASE_URI + 'searchByAccountingLineForIds',
        advancedSearchBackendOnly: BASE_URI + 'searchByAccountingLine',
        advancedSearchBackendOnlyCount: BASE_URI + 'searchByAccountingLineCount',
        print: BASE_URI + 'print/accountingLine'
      }
    };

        urls[roles.BTA_MANAGER] = {
                    all: {
                        filter: BASE_URI + 'search/findByBillingDate'
                    }
                };

        return urls;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/constants.js
// module id = 507
// module chunks = 0